import { useCallback, useEffect, useState } from 'react';
import { listAnalyticsRuleOptions } from '../../services/violations';
import { APP_EVENTS, useAppEvent } from '../../utils/appEvents';

/**
 * BM-FE-TZ-002C: выбранные в фильтре правила, которых больше нет в списке
 * правил вкладки (правило перевели в другую категорию). Сверка — по всему
 * ACL-aware списку категории без сужения по объектам: правило чужой камеры
 * в выбранной области — не повод убирать его из фильтра. Пока список не
 * получен или запрос упал, ничего не считается устаревшим: выбрасывать выбор
 * по неполным данным нельзя.
 */
export const useStaleRuleIds = (kind, ruleIds, enabled) => {
  const [stale, setStale] = useState([]);
  const ruleKey = (ruleIds || []).join(',');
  const [token, setToken] = useState(0);
  const recheck = useCallback(() => setToken((value) => value + 1), []);
  useAppEvent(APP_EVENTS.RULE_CATEGORY_CHANGED, recheck);

  useEffect(() => {
    setStale([]);
    if (!enabled || !ruleKey) return undefined;
    const controller = new AbortController();
    listAnalyticsRuleOptions(kind, {}, { signal: controller.signal })
      .then(({ items }) => {
        if (controller.signal.aborted) return;
        const known = new Set(items.map((rule) => String(rule.rule_id)));
        setStale(ruleKey.split(',').filter((id) => !known.has(id)));
      })
      .catch(() => {});
    return () => controller.abort();
  }, [enabled, kind, ruleKey, token]);

  return stale;
};

export default useStaleRuleIds;
